
<template>
    <el-dialog title="提示" :visible.sync="filedialog" width="30%" :before-close="close">
        <p class="talktitle">确认发送以下文件吗？</p>
        <div class="selcon" v-if="tdata.type==5">
            <div class="filecon">
                <b class="iconfont doc" v-if="tdata.data.st =='doc'">&#xe737;</b>
                <b class="iconfont xls" v-if="tdata.data.st =='xls'">&#xe732;</b>
                <b class="iconfont ppt" v-if="tdata.data.st =='ppt'">&#xe731;</b>
                <b class="iconfont pdf" v-if="tdata.data.st =='pdf'">&#xe733;</b>
                <p>{{tdata.data.fname}}</p>
                <span>{{tdata.data.fsize}}</span>
            </div>
        </div>

        <div class="selcon imgcon" v-if="tdata.type==2">
            <img :src="tdata.data.con" alt="">
        </div>

        <div class="selcon videocon" v-if="tdata.type==4">
            <video controls :src="tdata.data.con"></video>
        </div>

        <div class="selcon mp3con" v-if="tdata.type==3">
            <audiopaly bg="hui" :mp3url="tdata.data.con"></audiopaly>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="send">确 定</el-button>
        </div>
    </el-dialog>

</template>

<script>
    import {
        mapGetters,
        mapMutations
    } from 'vuex'
    import {
        checkWeChatMsg
    } from '@/utils/api-im.js'
    import uploadfile from '@/utils/upload.js'
    import audiopaly from '@/components/mp3Play'
    export default {
        name: 'seltalk',
        data() {
            return {
                tdata:{}
            }
        },
        components:{
            audiopaly
        },
        props:{
            filedialog:'',
            sdata:{}
        },
        computed: {
            ...mapGetters('im', [
                'selectfriendids'
            ])
        },
        watch:{
            filedialog(){
                this.tdata = this.sdata
            }
        },
       mounted() {

        },
        methods: {
            ...mapMutations('im', [
                'MSGID'
            ]),
            // 发送文件
            send(){
                //获取oss
                this.$emit('changeload',true)
                uploadfile.getossbase(this.tdata.file,true).then(osdata => {
                    //上传
                    this.$emit('closefile')
                    uploadfile.uploadform(osdata).then(updata => {
                        //成功回调
                        this.uploadSuccess(updata, osdata.fileidlist)
                        this.$emit('changeload')
                    }).catch(err=>{
                        this.$emit('changeload')
                    })
                }).catch(err=>{
                    this.$emit('changeload')
                })
            },
            uploadSuccess(data, fileidlist) {
                let {
                    file,
                    uuid
                } = data
                let contenttype = null
                let filecon = {}
                let filesize =file.size
                if(filesize>1024){
                    filesize=filesize/1024
                    filesize = filesize.toFixed(1) + 'kb'
                }else if(filesize/1024>1024){
                    filesize = filesize/1024/1024
                    filesize = filesize.toFixed(1) + 'mb'
                }else{
                    filesize = filesize+'b'
                }
                // {"linkUrl":"","coverUrl":"","source":"微信电脑版","title":"www.docx","type":"6","typeStr":"[文件]","fileSize":"10.7KB","fileSuffix":"docx","des":"10.7KB, docx"}
                if (file.type === 'image/jpeg' || file.type === 'image/png') {
                    contenttype = 2
                    filecon = {
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename
                    }
                    filecon.LinkUrl = fileidlist[uuid].host + fileidlist[uuid].filename
                }else if (file.type === 'audio/mp3') {
                    contenttype = 8
                    filecon = {
                        Title: file.name,
                        Type:6,
                        TypeStr:"[文件]",
                        Des:filesize+', mp3',
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename
                    }
                    filecon.Url = fileidlist[uuid].host + fileidlist[uuid].filename
                }else if (file.type === 'video/mp4') {
                    contenttype = 4
                    filecon = {
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename +
                            "?x-oss-process=video/snapshot,t_0,m_fast",
                    }
                    filecon.LinkUrl = fileidlist[uuid].host + fileidlist[uuid].filename
                }else{
                    contenttype = 8
                    let fileSuffix = fileidlist[uuid].type.replace('.','')
                    filecon = {
                        Title: file.name,
                        Type:6,
                        TypeStr:"[文件]",
                        Des:filesize+', '+fileSuffix,
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename,
                    }
                    filecon.Url = fileidlist[uuid].host + fileidlist[uuid].filename
                }

                let suuid = uploadfile.generateUUID()
                filecon = JSON.stringify(filecon)
                this.MSGID(suuid) //保存uuid

                this.socketApi.sendSock({
                    msgType: "TALK_TO_FRIEND_REQ",
                    msgContent: {
                        weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                        friendId: this.selectfriendids.wechatContactinfo.friendid,
                        contentType: contenttype,
                        content: filecon,
                        sendUuid: suuid
                    }
                })
            },
            // 上传失败回调
            uploadError(res) {
                console.log(res, '上传失败')
                this.$emit('changeload')
            },

            close() {
                this.$emit('closefile')
            },

            showtoast() {
                this.$toast('showtoast');
            },
        }
    };
</script>
<style lang="less" scoped>
    .talktitle{
        height:20px;
        font-size:14px;
        color:rgba(42,42,42,1);
        line-height:20px;
        margin-bottom: 20px;
    }
    .selcon {
        padding: 14px 26px 14px 22px;
        background: rgba(249, 250, 252, 1);
        border-radius: 3px;
        line-height: 22px;
        font-size: 12px;
        cursor: pointer;
        margin-bottom: 10px;

        &.mp3con{
            padding: 0;
            width: 390px;
            margin: 0 auto;
        }

        &.imgcon,&.videocon{
            padding: 0;
            background: #fff;
            overflow-y: auto;
            max-height: 500px;

            img,video{
                max-width: 100%;
            }

        }

        .txtcon {
            max-height: 68px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .filecon{
            padding-left: 46px;
            position: relative;

            b{
                position: absolute;
                top: 0;
                left: 0;
                font-size: 36px;
                height: 44px;
                line-height: 44px;
            }

            .doc{
                color: #5DACFF;
            }

            .xls{
                color: #5ACC9B;
            }

            .ppt{
                color: #FF8A76;
            }

            .pdf{
                color: #FF6969;
            }

            p{
                font-size: 14px;
                color: #2A2A2A;
            }

            span{
                font-size: 12px;
                color: #93999F;
            }
        }
    }


</style>
<style>
    .el-dialog {
        border-radius: 6px;
    }

</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/selfile.vue